// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";

Vue.config.productionTip = false;

// 全局变量及方法
import "@/utils/global.js";

// element-ui
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

// 加载全局组件
let AppHeader = resolve => {
  require(["@/components/header2.vue"], resolve);
};
let AppFooter = resolve => {
  require(["@/components/footer.vue"], resolve);
};
Vue.component("appHeader", AppHeader);
Vue.component("appFooter", AppFooter);


// 剪切板组件
import Clipboard from "v-clipboard";
Vue.use(Clipboard);

// 360浏览器兼容性优化插件
import "babel-polyfill";

// iconpark
import {CheckOne} from '@icon-park/vue'
import '@icon-park/vue/styles/index.css';
Vue.use(CheckOne);

// 整屏滚动组件
// import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
// // import './fullpage.scrollHorizontally.min' // Optional. When using fullpage extensions
// import VueFullPage from 'vue-fullpage.js'
// Vue.use(VueFullPage);

// 总线
Vue.prototype.$bus = new Vue();

// 路由跳转前置
// router.beforeEach((to, from, next) => {
//   if (to.matched.length === 0) {  //如果未匹配到路由
//     from.path? next({ path:from.path}) : next('/');   //如果上级也未匹配到路由则跳转主页面，如果上级能匹配到则转上级路由
//   } else {
//     next();    //如果匹配到正确跳转
//   }
// });

router.afterEach((to, from) => {
  // 每次进入路由都会触发
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(["_setAutoPageview", false]);
      window._hmt.push([
        "_trackPageview",
        "/template/displayTemplate/dist/index.html#" + to.fullPath
      ]); // 如果不是根路径，需要指定第二个参数的路径
    }
  }
});

Vue.mixin({
  beforeCreate() {
    const options = this.$options;

    this.$hm =
      options.parent && options.parent.$hm
        ? options.parent.$hm
        : (function(window) {
            if (!window._hmt) {
              return;
            }
            return Object.assign({}, window._hmt, {
              // 统计页面的点击事件
              click: (category, val) => {
                const userInfo = store.getters.userInfo || {};
                return window._hmt.push([
                  "_trackEvent",
                  category,
                  "click",
                  userInfo.loginName || "notLogin",
                  val
                ]);
              }
            });
          })(window);
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js